import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Search, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden pt-20 pb-32 lg:pt-32" data-id="element-109">
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-50 via-white to-blue-50 -z-10" data-id="element-110" />

      {/* Dynamic Gradient Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-purple-400/20 rounded-full blur-3xl animate-float" data-id="element-111" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-400/20 rounded-full blur-3xl animate-float" style={{
      animationDelay: '2s'
    }} data-id="element-112" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-113">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/50 backdrop-blur-sm border border-slate-200 text-sm font-medium text-slate-600 mb-8 shadow-sm" data-id="element-115">
            <Sparkles className="w-4 h-4 text-purple-600" data-id="element-116" />
            <span data-id="element-117">The #1 Platform for Software Discovery</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-5xl md:text-7xl font-extrabold tracking-tight text-slate-900 mb-6 leading-tight" data-id="element-118">
            Discover the Best Tools for <br className="hidden md:block" data-id="element-119" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-blue-600 to-cyan-500 animate-gradient-x" data-id="element-120">
              Every Task
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-xl text-slate-600 mb-10 max-w-2xl leading-relaxed" data-id="element-121">
            Find the perfect software solutions for your needs on{' '}
            <a href="https://keyanalyzer.com/" className="text-blue-600 hover:underline font-medium" data-id="element-122">
              Keyanalyzer.com
            </a>
            . Compare top-rated tools, read authentic reviews, and streamline
            your workflow today.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center gap-4 w-full justify-center" data-id="element-123">
            <a href="https://keyanalyzer.com/" className="w-full sm:w-auto inline-flex items-center justify-center px-6 py-3 text-base font-medium text-white bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 rounded-lg transition-all shadow-lg hover:shadow-xl" data-id="element-124">
              <Search className="w-5 h-5 mr-2" data-id="element-125" />
              Explore Tools on Keyanalyzer
            </a>
            <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-126">
              Learn More
              <ArrowRight className="w-5 h-5 ml-2" data-id="element-127" />
            </Button>
          </motion.div>

          {/* Abstract Dashboard Preview */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="mt-20 relative w-full max-w-5xl" data-id="element-128">
            <div className="relative rounded-xl bg-slate-900/5 p-2 ring-1 ring-inset ring-slate-900/10 lg:-m-4 lg:rounded-2xl lg:p-4" data-id="element-129">
              <div className="rounded-lg bg-white shadow-2xl overflow-hidden border border-slate-200 aspect-[16/9] flex items-center justify-center bg-slate-50" data-id="element-130">
                <div className="text-center p-8" data-id="element-131">
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-100 to-blue-100 rounded-2xl mx-auto mb-4 flex items-center justify-center" data-id="element-132">
                    <Search className="w-8 h-8 text-blue-600" data-id="element-133" />
                  </div>
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-134">
                    Interactive Tool Finder
                  </h3>
                  <p className="text-slate-500 mb-4" data-id="element-135">
                    Browse thousands of software reviews at
                  </p>
                  <a href="https://keyanalyzer.com/" className="text-blue-600 font-semibold hover:underline" data-id="element-136">
                    keyanalyzer.com
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}